// src/redux/loginUser.js

import axios from 'axios';
import {jwtDecode} from 'jwt-decode'; // Corrected import
import { loginSuccess, loginFailure } from './userSlice'; // Import loginFailure
import { API_BASE_URL } from '../config/config';

export const loginUser = (userId, password) => async (dispatch) => {
  try {
    // Send { userId, password } instead of { email, password }
    const response = await axios.post(`${API_BASE_URL}api/login`, { userId, password });

    const { token, user } = response.data;

    // Store token in localStorage
    localStorage.setItem('token', token);

    // Decode the token to get information
    const decodedToken = jwtDecode(token);
    console.log("Decoded Token Information:", decodedToken);

    // Dispatch success to Redux
    dispatch(loginSuccess({ token, user }));

    return true;  // Return true if login is successful
  } catch (error) {
    // Handle login error
    const errorMessage = error.response?.data?.message || error.message;
    console.error("Login failed:", errorMessage);
    dispatch(loginFailure(errorMessage)); // Dispatch failure action

    return false;  // Return false if login fails
  }
};
